import { useDispatch, useSelector } from 'react-redux';
import uiActions from '@/actions/experimentDetails/uiActions';
import { getIsHeaderTableShown } from '@/reducers/experimentDetails/uiReducer';

const useExperimentDetailIsTableShown = () => {
  const dispatch = useDispatch();
  const isHeaderTableShown = useSelector(getIsHeaderTableShown);

  const handleClickIsTableShown = () => {
    dispatch(uiActions.setIsHeaderTableShownStatus(!isHeaderTableShown));
  };

  return {
    handleClickIsTableShown
  };
};

export default useExperimentDetailIsTableShown;
